/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTransaction} from '../api'

 export const useQueryGetTransaction = createReactQueryHook('getTransaction', getTransaction)
